import { render, staticRenderFns } from "./TributeSuperModal.vue?vue&type=template&id=40a941a8"
import script from "./TributeSuperModal.vue?vue&type=script&lang=js"
export * from "./TributeSuperModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports